import './subscriptionCard.css'
import { motion } from 'framer-motion'
import { OverlayTrigger } from "react-bootstrap";
import { Tooltip } from "react-bootstrap";
import ReactBootstrapModal from '../modals/ReactBootstrapModal';
import { RenewAlert } from '../../Routes/RenewSubscription/Renew-Alert/RenewAlert';
import logger from '../../../utils/logger';
import { dateFormat } from '../../../helper/dataFormat';
import { useEffect, useState } from 'react';
import { getStateInfo } from '../../../helper/stateTranslate';


export const RenewCard = ({ handleShow, handleClose, show, objectToSend, data, subscriptionModel }) => {


    const [translationStatus, setTranslationStatus] = useState(null)

    useEffect(() => {

        if (data.state) {

            const getState = getStateInfo(subscriptionModel, data.state)
            logger.info('status translationStatus: ', getState)

            setTranslationStatus(getState)
        }

    }, [data])



    const variants = {
        hidden: { opacity: 0, x: 20 },
        visible: { opacity: 1, x: 0, transition: { duration: 0.5 } }
    }

    return (
        <>
            <div className='col-12 col-lg-6 d-flex justify-content-center'>
                <div className="card-basic m-2">
                    <div className="card-header header-basic">
                        <div className='h1Container'>
                            <h1>Membresía</h1>
                        </div>
                        <div className='h4Container'>
                            <h4>id: {data.id}</h4>
                        </div>


                    </div>
                    <div className="card-body">

                        <div className="card-element-hidden-basic">
                            <ul className="card-element-container">
                                {/* <li className="card-element"><h3>id: 4</h3></li> */}
                                <li className="card-element mb-2">
                                    <b>Estado: </b>
                                    <span className={`span-status span-status-heigth span-${data.state.toLowerCase()}`}>{translationStatus?.stateString}</span>
                                </li>
                                <li className="card-element"><b>Fecha de vencimiento: </b>{dateFormat(data.expirationDate)}</li>

                            </ul>
                            {/* <button className="btn btn-basic">Order now</button> */}
                            <OverlayTrigger
                                placement="bottom"
                                overlay={<Tooltip id={`tooltip-renew}`}>Renovar Suscripción</Tooltip>}
                            >
                                <div className="mt-auto">
                                    <button onClick={handleShow}>
                                        <span className="btn btn-basic material-symbols-outlined notranslate pointer " enrollment-id="4" member-id="4">refresh</span>
                                    </button>
                                </div>
                            </OverlayTrigger>
                        </div>
                    </div>
                </div>
            </div>


            <ReactBootstrapModal
                toggleModal={handleClose}
                showModal={show}
                modalClass={'modalAlert'}
            >
                <RenewAlert handleClose={handleClose} objectToSend={objectToSend} />

            </ReactBootstrapModal>

        </>
    )
}
